import { render } from "./HamburgerMenu.vue?vue&type=template&id=49b44f0d&scoped=true"
import script from "./HamburgerMenu.vue?vue&type=script&lang=js"
export * from "./HamburgerMenu.vue?vue&type=script&lang=js"

import "./HamburgerMenu.vue?vue&type=style&index=0&id=49b44f0d&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49b44f0d"]])

export default __exports__